import { alpha, Avatar, Typography } from '@mui/material';
import React from 'react';
import I18n from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';
import { H, V } from '../../Layout';
import { useStyling } from '../../Theme';
import type { ShareOption } from './ShareInfo';

type ShareOptionDisplayProps = {
    option: ShareOption;
    showDropdown?: boolean;
};

export function ShareOptionDisplay({ option, showDropdown = false }: ShareOptionDisplayProps) {
    const { theme, isMobile } = useStyling();

    return (
        <>
            {option?.icon && (
                <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.08) }}>
                    <option.icon sx={{ fontSize: 25, color: 'primary.main' }} />
                </Avatar>
            )}
            <V gap={0.25}>
                <H gap={0.5} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
                    <Typography
                        sx={{
                            fontSize: isMobile ? '14px' : '16px',
                            color: 'text.primary'
                        }}
                    >
                        <I18n token={option.labelToken} />
                    </Typography>
                    {showDropdown && <Icons.ArrowDropDownOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />}
                </H>
                <Typography sx={{ fontWeight: theme.typography.subtitle2, color: 'text.disabled' }}>
                    <I18n token={option.descriptionToken} />
                </Typography>
            </V>
        </>
    );
}
